import React,{ useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getApprovedProducts } from '../../redux/actions/ProductActions';
import { connect } from 'react-redux';
import Banner from '../../components/Banner';
import Loader from '../../components/Loader';
import Header from '../../components/header/Header';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/Footer';
import Message from '../../components/Message';
import Rating from '../../components/Rating';
// import CookieBanner from '../../cookie/CookieBanner';
// import posthog  from 'posthog-js';


const HomeScreen = ({ approvedProducts, getApprovedProducts }) => {


    useEffect(() => {

        window.scrollTo(0,0)       
        getApprovedProducts()

    }, [getApprovedProducts]);


    const { loading, products, error } = approvedProducts;

    
    return (
        <div>
            <Header />
            <Navbar />
            <Banner />
            <div className='container max-w-screen-xl mx-auto px-4 md:px-2 mb-28'>
                <div className='flex justify-center flex-col items-center mb-16'>
                    <h2 className='font-normal text-black text-3xl uppercase mb-1 mont-font'>Lasted Products</h2>
                    <div className='w-28 bg__color' style={{ height: '.2rem' }}></div>
                </div>
                {
                    loading ? <Loader /> : error ? <Message error msg={error} /> : (
                        <div className=' grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4 gap-y-7 my-5 '>
                            {
                                products.map((val) => (
                                    <div key={val._id} >
                                        <div className='bg-white shadow-md rounded-lg hi'>
                                            <Link to={`/product/${val._id}`}>
                                                <img src={val.image} alt={val.name} className='w-full cursor-pointer object-cover h-60 rounded-t-lg' />
                                            </Link>
                                            <div className='p-4'>
                                                <Link to={`/product/${val._id}`} className='hover:underline product__name cursor-pointer mont-font'>{val.name}</Link>
                                                <Rating value={val.rating} text={`${val.numReviews} reviews`} />
                                                <div className='font-semibold text-xl'>₹{val.price}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }
            </div>
            {/* { posthog.has_opted_in_capturing() || posthog.has_opted_out_capturing() ? null : <CookieBanner /> } */}
            <Footer />
        </div>
    )
}

const mapStateToProps = (state) => ({
    approvedProducts: state.approvedProducts
})

export default connect(mapStateToProps, { getApprovedProducts })(HomeScreen);